// biome-ignore-all lint:no-explicit-any

import { useTranslation } from '@repo/roche-xx-shared';
import {
  RocheUIMultipleAlternatives,
  RocheUIResponsiveTable,
  RocheUITable,
  RocheUITextAlignment,
} from '@rocheglobal/roche-ui';

import React from 'react';
import { rocheResponsiveTableTracking } from '../../helpers/roche-responsive-table-tracking';

type TableCell = {
  _uid: string;
  value: string;
  component: '_table_col';
};

type TableRow = {
  _uid: string;
  body: TableCell[];
  component: '_table_row';
};

type TableHeader = {
  _uid: string;
  value: string;
  component: '_table_head';
};

type Table = {
  thead: TableHeader[];
  tbody: TableRow[];
  fieldtype: 'table';
};

type RocheResponsiveTableBlok = {
  _uid: string;
  table: Table;
  caption: string;
  sortable: boolean;
  component: 'roche-responsive-table';
  align_text: RocheUITextAlignment;
  filterable: boolean;
  sticky_header: boolean;
  alternated_row: string;
  alternated_column: string;
  multiple_alternatives: RocheUIMultipleAlternatives;
};

type RocheResponsiveTableProps = {
  getComponent: any;
  blok: RocheResponsiveTableBlok;
  slot?: string;
  storyId: number;
  [key: string]: any;
};

const mapStoryblokTableToRocheUITable = (table: Table): RocheUITable => {
  return {
    thead: table.thead.map((header) => ({
      id: header._uid,
      value: header.value,
    })),
    tbody: table.tbody.map((row) => ({
      id: row._uid,
      body: row.body.map((cell) => ({
        id: cell._uid,
        value: cell.value,
      })),
    })),
  };
};

export const RocheResponsiveTable = ({ blok }: RocheResponsiveTableProps): JSX.Element | null => {
  if (!blok.table) {
    return null;
  }

  const mappedTable = mapStoryblokTableToRocheUITable(blok.table);

  return (
    <RocheUIResponsiveTable
      table={mappedTable}
      caption={blok.caption}
      stickyHeader={blok.sticky_header}
      sortable={blok.sortable}
      filterable={blok.filterable}
      noResults={useTranslation('sorry, no results found.')}
      alignText={blok.align_text}
      alternatedColumn={blok.alternated_column}
      alternatedRow={blok.alternated_row}
      multipleAlternatives={blok.multiple_alternatives}
      filterInputPlaceholder={useTranslation('filter')}
      clearFilterText={useTranslation('clear filter')}
      onResponsiveTableEvent={(event) => rocheResponsiveTableTracking(event)}
    ></RocheUIResponsiveTable>
  );
};
